import api from "../../../utils/api";

export const createTicketUpdate = async ({ attachments = [], ...payload }) => {
  if (process.env.NODE_ENV === "development") console.log(payload, attachments);

  // If attachments are provided, use FormData
  if (attachments && attachments.length > 0) {
    const formData = new FormData();

    // Append all payload fields to FormData
    Object.keys(payload).forEach((key) => {
      if (payload[key] !== null && payload[key] !== undefined) {
        formData.append(key, payload[key]);
      }
    });

    // Append all attachments to FormData
    attachments.forEach((file) => {
      formData.append("attachments", file);
    });

    const res = await api.post("/ticket_updates/", formData);
    return res.data;
  }

  // Otherwise, send as JSON
  const res = await api.post("/ticket_updates/", payload);
  return res.data;
};

export const readTicketUpdate = async (publicId) => {
  if (!publicId) throw new Error("Missing or invalid ID for ticket update");
  const res = await api.get(`/ticket_updates/${publicId}`);
  return res.data;
};

export const readTicketUpdates = async (params) => {
  const res = await api.get("/ticket_updates", { params });
  return res.data;
};

export const updateTicketUpdate = async ({ attachments = [], ...payload }) => {
  if (process.env.NODE_ENV === "development") console.log(payload, attachments);
  if (!payload.publicId) throw new Error("Missing or invalid ID for ticket update");

  // If attachments are provided, use FormData
  if (attachments && attachments.length > 0) {
    const formData = new FormData();
    const { publicId, ...bodyFields } = payload;

    // Append all payload fields to FormData (excluding id, which goes in the URL)
    Object.keys(bodyFields).forEach((key) => {
      if (bodyFields[key] !== null && bodyFields[key] !== undefined) {
        formData.append(key, bodyFields[key]);
      }
    });

    // Append all attachments to FormData
    attachments.forEach((file) => {
      formData.append("attachments", file);
    });

    const res = await api.put(`/ticket_updates/${payload.publicId}`, formData);
    return res.data;
  }

  // Otherwise, send as JSON
  const res = await api.put(`/ticket_updates/${payload.publicId}`, payload);
  return res.data;
};

export const retryTicketUpdateEmail = async (publicId) => {
  if (process.env.NODE_ENV === "development") console.log(publicId);
  if (!publicId) throw new Error("Invalid ID for ticket update!");
  const res = await api.post(`/ticket_updates/${publicId}/retry-email`);
  return res.data;
};

export const deleteTicketUpdate = async (publicId) => {
  if (process.env.NODE_ENV === "development") console.log(publicId);
  if (!publicId) throw new Error("Invalid ID for ticket update!");
  const res = await api.delete(`/ticket_updates/${publicId}`);
  return res.data;
};

export const translateContent = async (text, sourceLanguage, targetLanguage) => {
  const payload = {
    text,
    source: sourceLanguage || "auto",
    target: targetLanguage,
  };
  const res = await api.post("/translate", payload);
  return res.data;
};
